module.exports = __webpack_public_path__ + "static/media/profile-icon-active.a93da504.svg";